export default "images/bg8.jpg";